import { Controller } from '@hotwired/stimulus'
import { useDebounce } from 'stimulus-use'
import { get } from '@rails/request.js'

// Connects to data-controller="ransack-form"
export default class extends Controller {
  static debounces = ['search']

  connect () {
    useDebounce(this, { wait: 500 })

    this.element.addEventListener('reset', this.search.bind(this))
  }

  disconnect () {
    this.element.removeEventListener('reset', this.search.bind(this))
  }

  search () {
    if (this.element.dataset.turbo) {
      const formData = new window.FormData(this.element)
      const searchParams = new URLSearchParams(formData) // FIXME: Does not work with pre-chromium edge. Fix if solution is accepted.
      const url = `${this.element.action}?${searchParams.toString()}`

      get(url, {
        responseKind: 'turbo-stream'
      })

      return
    }

    this.element.requestSubmit()
  }
}
